/**
 * CSS custom properties for the indent (spacer) widget — the TS twin of
 * `indent.base.less` next to it, and the smallest of the set: one measurement,
 * per breakpoint. Shared by the editor (websites) and the published renderer
 * (websites-builder).
 *
 * One function per variable, each taking the whole `height` value: the `tablet` /
 * `mobile` leaves are optional, and a `null` removes the variable so the LESS keeps
 * the desktop height — as the old JSS did by emitting no device rule.
 */

export type IndentHeight = { desktop: number; tablet?: number | null; mobile?: number | null };

const px = (height: number | null | undefined): string | null => (height != null ? `${height}px` : null);

export function indentHeightCss(height: IndentHeight): string | null {
    return px(height.desktop);
}

/**
 * The tablet leaf, else the mobile one: legacy applied the mobile height up to
 * 992px, tablet included, and a spacer without a tablet leaf keeps that.
 */
export function indentTabletHeightCss(height: IndentHeight): string | null {
    return px(height.tablet ?? height.mobile);
}

export function indentMobileHeightCss(height: IndentHeight): string | null {
    return px(height.mobile);
}
